(function () {
  'use strict';

  function initBlurUpImages(root) {
    root.querySelectorAll('.img-hd-source').forEach(function (img) {
      function markLoaded() {
        img.classList.add('is-loaded');
      }

      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded, { once: true });
      }
    });
  }

  function setupBanner(root) {
    if (!root || root.dataset.kbdBannerInit === 'true') return;
    root.dataset.kbdBannerInit = 'true';

    initBlurUpImages(root);

    var track = root.querySelector('.mt-kbd-banner__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mt-kbd-banner__slide'));
    var progressItems = Array.prototype.slice.call(
      root.querySelectorAll('.mt-kbd-banner__progress-item')
    );
    var prevBtn = root.querySelector('[data-kbd-banner-prev]');
    var nextBtn = root.querySelector('[data-kbd-banner-next]');

    if (!track || slides.length === 0) return;

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var duration = parseInt(root.dataset.duration, 10) || 5000;
    var showProgress = root.dataset.showProgress !== 'false';
    var current = 0;
    var timer = null;
    var paused = false;
    var hydrated = false;
    var observer = null;
    var videoCleanup = null;

    function getVideos(slide) {
      return slide ? Array.prototype.slice.call(slide.querySelectorAll('video')) : [];
    }

    function isVideoSlide(index) {
      return slides[index] && slides[index].dataset.slideType === 'video';
    }

    function playSlideMedia(index) {
      slides.forEach(function (slide, i) {
        getVideos(slide).forEach(function (video) {
          video.loop = false;
          if (i === index) {
            video.currentTime = 0;
            video.play().catch(function () {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      });
    }

    function resetProgressFill(item) {
      if (!item) return;
      var fill = item.querySelector('.mt-kbd-banner__progress-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0';
      void fill.offsetWidth;
    }

    function resetProgressForIndex(index) {
      progressItems.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
        item.classList.remove('is-animating');
        resetProgressFill(item);
      });
    }

    function animateProgress(index, progressDuration) {
      if (!showProgress || !autoplayEnabled || slides.length <= 1) return;

      resetProgressForIndex(index);

      var activeItem = progressItems[index];
      if (!activeItem || paused) return;

      var fill = activeItem.querySelector('.mt-kbd-banner__progress-fill');
      if (!fill) return;

      requestAnimationFrame(function () {
        activeItem.classList.add('is-animating');
        fill.style.transition = 'width ' + progressDuration + 'ms linear';
        fill.style.width = '100%';
      });
    }

    function clearAutoplay() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      if (videoCleanup) {
        videoCleanup();
        videoCleanup = null;
      }
    }

    function scheduleImageAutoplay(index) {
      animateProgress(index, duration);
      timer = setTimeout(function () {
        goTo((index + 1) % slides.length, false);
      }, duration);
    }

    function scheduleVideoAutoplay(index) {
      var slide = slides[index];
      var video = getVideos(slide)[0];

      if (!video) {
        scheduleImageAutoplay(index);
        return;
      }

      video.loop = false;
      resetProgressForIndex(index);

      function onEnded() {
        goTo((index + 1) % slides.length, false);
      }

      function onTimeUpdate() {
        if (!showProgress || !autoplayEnabled || paused) return;
        if (!video.duration || !isFinite(video.duration)) return;

        var activeItem = progressItems[index];
        if (!activeItem) return;

        var fill = activeItem.querySelector('.mt-kbd-banner__progress-fill');
        if (!fill) return;

        activeItem.classList.add('is-active', 'is-animating');
        fill.style.transition = 'none';
        fill.style.width = (video.currentTime / video.duration) * 100 + '%';
      }

      video.addEventListener('ended', onEnded);
      video.addEventListener('timeupdate', onTimeUpdate);

      videoCleanup = function () {
        video.removeEventListener('ended', onEnded);
        video.removeEventListener('timeupdate', onTimeUpdate);
      };

      if (video.paused) {
        video.play().catch(function () {
          scheduleImageAutoplay(index);
        });
      }
    }

    function scheduleAutoplay() {
      clearAutoplay();
      if (!hydrated || !autoplayEnabled || slides.length <= 1 || paused) return;

      if (isVideoSlide(current)) {
        scheduleVideoAutoplay(current);
      } else {
        scheduleImageAutoplay(current);
      }
    }

    function goTo(index, userTriggered) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + current * 100 + '%, 0, 0)';

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });

      progressItems.forEach(function (item, i) {
        item.classList.toggle('is-active', i === current);
        item.setAttribute('aria-current', i === current ? 'true' : 'false');
      });

      clearAutoplay();
      playSlideMedia(current);

      if (userTriggered || !autoplayEnabled) {
        resetProgressForIndex(current);
        if (autoplayEnabled) scheduleAutoplay();
      } else {
        scheduleAutoplay();
      }
    }

    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      goTo(current, false);
    }

    function pause() {
      paused = true;
      root.classList.add('is-paused');
      clearAutoplay();
      getVideos(slides[current]).forEach(function (video) {
        video.pause();
      });
    }

    function resume() {
      paused = false;
      root.classList.remove('is-paused');

      if (isVideoSlide(current)) {
        var video = getVideos(slides[current])[0];
        if (video) {
          if (video.ended) {
            goTo((current + 1) % slides.length, false);
            return;
          }
          video.play().catch(function () {});
        }
      }

      scheduleAutoplay();
    }

    progressItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        goTo(index, true);
      });
    });

    function onPrevClick() {
      goTo(current - 1, true);
    }

    function onNextClick() {
      goTo(current + 1, true);
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
    if (nextBtn) nextBtn.addEventListener('click', onNextClick);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!hydrated) {
                hydrate();
              } else {
                resume();
              }
            } else {
              pause();
            }
          });
        },
        { root: null, threshold: 0.15 }
      );
      observer.observe(root);
    } else {
      hydrate();
    }

    root._kbdBannerDestroy = function () {
      clearAutoplay();
      if (observer) observer.disconnect();
      if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
      if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
      delete root.dataset.kbdBannerInit;
      delete root._kbdBannerDestroy;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mt-kbd-banner').forEach(setupBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.mt-kbd-banner').forEach(function (banner) {
      if (typeof banner._kbdBannerDestroy === 'function') {
        banner._kbdBannerDestroy();
      }
    });
  });
})();
